export const REQ_DATA = 'REQ_DATA';

export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

export const GET_AUTOCOMPLETE_SUCCESS = 'GET_AUTOCOMPLETE_SUCCESS';
export const GET_AUTOCOMPLETE_FAILURE = 'GET_AUTOCOMPLETE_FAILURE';

export const SET_AREAS_BY_RADIUS = 'SET_AREAS_BY_RADIUS';
export const SET_AREAS_BY_REGION = 'SET_AREAS_BY_REGION';

export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';

const setAreasByRadius = (areasByRadius) => {
    return async dispatch => {

        try {
            dispatch({
                type: SET_AREAS_BY_RADIUS,
                payload: areasByRadius
            });
        } catch (e) {
            console.error(e);
        }
    };
}

const setAreasByRegion = (areasByRegion) => {
    return async dispatch => {

        try {
            dispatch({
                type: SET_AREAS_BY_REGION,
                payload: areasByRegion
            });
        } catch (e) {
            console.error(e);
        }
    };
}

const updateCategory = (category) => {
    return async dispatch => {

        try {
            dispatch({
                type: UPDATE_CATEGORY,
                payload: category
            });
        } catch (e) {
            console.error(e);
        }
    };
}

export {
    setAreasByRadius,
    setAreasByRegion,

    updateCategory,
}
